export default __webpack_public_path__ + "static/media/hero-poster-desktop.bd8a3586.jpg";